import { render, staticRenderFns } from "./InviteTeammatesForm.vue?vue&type=template&id=3d52a736&scoped=true"
import script from "./InviteTeammatesForm.vue?vue&type=script&lang=js"
export * from "./InviteTeammatesForm.vue?vue&type=script&lang=js"
import style0 from "./InviteTeammatesForm.vue?vue&type=style&index=0&id=3d52a736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52a736",
  null
  
)

export default component.exports